module.exports = __webpack_public_path__ + "img/57abeee.png";